import { apiClientRouter } from '@/api/softphone_api.js';
import { apiOfficialClient } from './config.js';

export default {
  getUserInfo(token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.get(`user_detail/`);
  },
  connectedUser(token, connected) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(`user_connection/`, connected);
  },
  getDisconnectLabels(token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.get(`disconnect-options-list/`);
  },
  getCountries(token) {
    apiClientRouter.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClientRouter.get(`api/admin/countries_list/?limit=1000`);
  },
  activeBot(token, connected) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(`activate-bot/`, connected);
    
  },
};
